export const contactInfo = [
					{
						iconName: "linkedin",
						info: "My LinkedIn Profile",
						color: "blue",
						link: "a",
						address:
							"https://www.linkedin.com/in/sam-thoyre-19829031/"
					},
					{
						iconName: "twitter",
						info: "@SamThoyre",
						color: "blue",
						link: "a",
						address: "https://twitter.com/SamThoyre"
					},
					{
						iconName: "mail",
						info: "sthoyre@gmail.com",
						color: "red",
						link: "a",
						address: "mailto: sthoyre@gmail.com"
					},
					{
						iconName: "phone",
						info: "919-605-4298",
						color: "black",
						link: "",
						address: ""
					}
				];
